import React, {Component} from 'react';

import {BrowserRouter as Router, Route} from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Announcements from './components/Announcements';
import Contact from './components/Contact';
import Navbar from "./components/CustomNavbar";
import Hashtag from './components/Hashtag';
import './App.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

library.add(faSearch)


class App extends Component {

    render() {

        return (
            <Router>
                <div>
                    <Navbar/>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/about" component={About}/>
                    <Route exact path="/contact" component={Contact}/>
                    <Route exact path="/announcements" component={Announcements}/>
                    <Route exact path="/hashtag/:idd" component={Hashtag}/>
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js